import { Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import GlobalLoadingUi from './loadingUi/GlobalLoadingUi';
import { AuthCheck } from './utils/Auth';
import Dashboard from './views/Dashboard/Dashboard';
import Login from './views/Login/Login';
import NotFound from './views/NotFound/NotFound';
import SplashScreen from './views/SplashScreen/SplashScreen';
import Admins from './views/Admin/Admins';
import AdminProfile from './views/Admin/AdminProfile';
import Users from './views/Users/Users';
import UserDetails from './views/Users/UserDetails';
import WithdrawRequests from './views/WithdrawRequest/WithdrawRequests';
import LinksList from './views/Links/LinksList';
import LinkDetails from './views/Links/LinkDetails';
import QRCodeList from './views/QRCode/QRCodeList';
import QRDetails from './views/QRCode/QRDetails';
import AllPages from './views/Pages/AllPages';
import PageDetails from './views/Pages/PageDetails';
import Feedback from './views/Feedback&Report/Feedback';
import Templates from './views/Templates/Templates';
import Setting from './views/Setting/Setting';
import UpdateSetting from './views/Setting/UpdateSetting';
import BusinessCards from './views/BusinessCards/BusinessCards';
import BusinessCardDetails from './views/BusinessCards/BusinessCardDetails';
import PlanRequests from './views/Plan/PlanRequests';
import GoogleAdsAccountRequest from './views/GoogleAds/GoogleAdsAccountRequest';
import PlanPurchasedList from './views/LiveChat/PlanPurchasedList';
import UserOrgList from './views/Organization/UserOrgList';

function App() {
  return (
    <div>
      <Toaster visibleToasts={3} duration={2000} theme='dark' richColors position='bottom-center' />
      <GlobalLoadingUi />
      <Routes>
        <Route element={<AuthCheck />} >
          <Route path='/dashboard' element={<Dashboard />} />

          <Route path='/users/:filter?' element={<Users />} />
          <Route path='/user/:userId' element={<UserDetails />} />
          <Route path='/user-org-list/:userId' element={<UserOrgList />} />

          <Route path='/admins' element={<Admins />} />
          <Route path='/admin-profile' element={<AdminProfile />} />

          <Route path='/links/:userId?' element={<LinksList />} />
          <Route path="/link-details" element={<LinkDetails />} />

          <Route path="/qr-codes/:userId?" element={<QRCodeList />} />
          <Route path='/qr-details' element={<QRDetails />} />

          <Route path='/pages/:userId?' element={<AllPages />} />
          <Route path='/page-details' element={<PageDetails />} />

          <Route path='/business-cards/:userId?' element={<BusinessCards />} />
          <Route path='/business-card-details' element={<BusinessCardDetails />} />

          <Route path='/withdraw-request' element={<WithdrawRequests />} />

          <Route path='/feedback' element={<Feedback />} />

          <Route path='/plan-request' element={<PlanRequests />} />

          <Route path='/chat-purchased-list' element={<PlanPurchasedList />} />

          <Route path='/google-ads-account-request' element={<GoogleAdsAccountRequest />} />

          <Route path='/templates' element={<Templates />} />

          <Route path='/settings' element={<Setting />} />
          <Route path='/update-setting/:settingId' element={<UpdateSetting />} />

        </Route>

        <Route path="/" element={<SplashScreen />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
